<template>
  <div class="container-fluid" v-if="isReady">
    <h3 style="margin-bottom: 30px">Participants</h3>
    <div class="table-options-wrapper">
      <div style="float: left">
        <Select
          v-model="selectedChannel"
          style="width: 200px; margin-bottom: 16px"
        >
          <Option value="Audio Room" key="0">Audio Room</Option>
          <Option value="Webcast" key="1">Webcast</Option>
        </Select>
      </div>
      <div style="float: right; margin-top: 6px">
        Audio connections:
        <b>
          <span v-if="audioParticipants.total">{{
            audioParticipants.total
          }}</span>
          <span v-else>0</span>
        </b>
        <span style="margin-left: 32px">Webcast connections:</span>
        <b>
          <span v-if="realtimeStats">{{ currentConnectionCount }}</span>
          <span v-else>0</span>
        </b>
      </div>
    </div>
    <AudioParticipantList v-if="selectedChannel == 'Audio Room'" />
    <WebcastParticipantList v-if="selectedChannel == 'Webcast'" />
  </div>
</template>

<script>
import $config from '@/config'
import AudioParticipantList from '@/components/webcast/selfService/AudioParticipantList.vue'
import WebcastParticipantList from '@/components/webcast/selfService/WebcastParticipantList.vue'

import { mapState, mapGetters, mapActions } from 'vuex'
import { database, db } from '@/firebase'
import _ from 'lodash'
export default {
  components: {
    AudioParticipantList,
    WebcastParticipantList
  },
  data() {
    return {
      selectedChannel: 'Audio Room',
      isReady: false,
      currentConnectionCount: 0,
      webcastUserList: {}
    }
  },
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('realtime-stats', {
      rtStats: 'getCopy'
    }),
    ...mapGetters('audio-participants', {
      participantsInStore: 'find'
    }),
    audioParticipants() {
      let query = {
        isOnCall: true,
        webcastId: this.webcast._id,
        $sort: {
          handRaisedAt: -1
        }
      }
      return this.participantsInStore({ query: query })
    },
    realtimeStats() {
      return this.rtStats
    }
  },
  methods: {
    ...mapActions('realtime-stats', {
      findStatsAction: 'find'
    })
  },
  created() {
    this.findStatsAction({
      query: {
        webcastId: this.webcast._id,
        sessionId: this.webcast.currentSessionId
      }
    }).then(async res => {
      if (res.total > 0) {
        console.log('store commit')
        this.$store.commit('realtime-stats/setCurrent', res.data[0])
      }

      if (this.webcast.newWebcastId) {
        const webcastRef = await db
          .doc(`event/${this.webcast.newWebcastId}`)
          .get()
        const newWebcast = webcastRef.data()

        if (newWebcast.currentSession) {
          const onlineRef = database()
            .ref(
              `event/${this.webcast.newWebcastId}/${newWebcast.currentSession}`
            )
            .orderByChild('status')
            .equalTo('playing')

          onlineRef.on('value', snapshot => {
            const list = _.values(snapshot.toJSON())
            this.webcastUserList = _.orderBy(list, 'createdAt', 'desc')
            this.currentConnectionCount = this.webcastUserList.length
          })
        }
      }

      this.isReady = true
    })
  }
}
</script>

<style>
.table-options-wrapper {
  display: inline-block;
  width: 100%;
}
</style>
